<app-background backgroundImage="images/shared/backgrounds/background-1.avif">
    <h1 class="sr-only">Website Marketing Services — Traffic, Conversion, and Paid Acquisition</h1>
    <app-hero-section height="520px" paddingTop="300px" opacity=".8"
        [backgroundImage]="`images/${file}/backgrounds/${file}.avif`" [title]="`images/${file}/${file}.svg`"
        text="service"></app-hero-section>
    <app-process></app-process>
</app-background>
<app-background backgroundImage="images/shared/backgrounds/background-3.avif">
    <div class="pt-[200px]">
        <app-info-card>
            <div class="flex flex-col justify-center items-center">
                <div class="font-outfit text-xl sm:text-3xl font-semibold mb-2 sm:mb-6">
                    marketing <span class="gradient-text">case studies</span>
                </div>
                <div class="font-inter mb-6 sm:mb-[21px] text-center text-sm sm:text-base">
                    See the <b>SEM Nexus</b> process in action. Join us and take a deep dive into our best marketing
                    work.
                </div>
                <app-button buttonText="see all case studies" (clicked)="goToCaseStudies()"></app-button>
            </div>
        </app-info-card>
    </div>
    <app-connect></app-connect>
</app-background>